mainApp.component('singleSignOn', {
    templateUrl: '/public/components/cloudAccess/single-sign-on.component.html',
    controller: function($state, $scope, AccountAuthService, GeneralUtilsService, GlobalCloudApplicationAuthenticationService, UserContextService, IntervalService) {

        var ctrl = this;

        ctrl.globalProviderUuidToAuthenticationProvider = function(uuid) {
            switch (uuid) {
                case 'GLOBAL_OAUTH2_AZURE':
                    return ctrl.catoAzureAuthenticationProvider;
																case 'GLOBAL_OAUTH2_AZURE_VER_1':
																				return ctrl.catoAzureVer1AuthenticationProvider;
																case 'GLOBAL_OAUTH2_GOOGLE':
																				return ctrl.catoGoogleAuthenticationProvider;
                default:
                    return {
                        name: uuid + ' - unknown provider',
                    };
            }
        }

        ctrl.oktaAuthenticationProvider = {
            name: 'Okta',
            method: 'OAUTH2',
            provider: 'OAUTH2_OKTA'
        };
        ctrl.oneloginAuthenticationProvider = {
            name: 'Onelogin',
            method: 'OAUTH2',
            provider: 'OAUTH2_ONELOGIN'
        };
								ctrl.iwelcomeAuthenticationProvider = {
												name: 'OneWelcome',
												method: 'OAUTH2',
												provider: 'OAUTH2_IWELCOME'
								};
        ctrl.catoAzureAuthenticationProvider = {
            name: "Azure",
            method: 'OAUTH2',
            provider: 'OAUTH2_AZURE'
        };
								ctrl.catoAzureVer1AuthenticationProvider = {
												name: "Azure",
												method: 'OAUTH2',
												provider: 'OAUTH2_AZURE_VER_1'
								};
								ctrl.catoGoogleAuthenticationProvider = {
												name: "Google",
												method: 'OAUTH2',
												provider: 'OAUTH2_GOOGLE'
								};
        ctrl.authenticationProviders = [];

        var defaultAuthMethodSettings = {
            authProvider : 'NONE'
        }

        ctrl.$onInit = function() {
            ctrl.init();
        };

        ctrl.$onDestroy = function() {
            IntervalService.cancelDynamicInterval($scope.$id, 'singleSignOnGetAzureTenant')
        }

		let updateExternalSystemConfiguration = function (data){
			ctrl.externalSystemConfiguration = data;
			ctrl.origExternalSystemConfiguration = angular.copy(data);
		};

        let initExternalSystem = function() {
			AccountAuthService.getExternalSystemConfiguration($state.params.accountId, updateExternalSystemConfiguration);

		};

        ctrl.init = function() {
            ctrl.getGlobalCloudApplicationAuthentication();
            ctrl.getAccountAuthSettings();
			initExternalSystem();
        }

        ctrl.isViewer = function() {
            return UserContextService.isDisableGUI();
        };

        ctrl.startInterval = () => {
            IntervalService.dynamicInterval(getAzureTenantFromService, $scope.$id, 'singleSignOnGetAzureTenant', true);
        };

        let getAzureTenantFromService = () => {
            AccountAuthService.getAzureTenant($state.params.accountId, ctrl.getAzureTenantCallback);
        }

        ctrl.getAzureTenantCallback = function(data) {
            if (data) {
                let tenantData = data.split(';');
                if (tenantData[0] && tenantData[0] !== 'null' && tenantData[1] && tenantData[1] !== 'null') {
                    ctrl.tenantId = tenantData[0];
                    ctrl.lastTenantUpdateDate = tenantData[1];
                }
            }
        }

        // required to show unsaved changes warning when switching to a different screen
        $scope.$root.hasChanges = function() {
            return ctrl.hasChanges();
        }

        function extenralSystemConfigurationChanged() {
        	return !angular.equals(ctrl.origExternalSystemConfiguration, ctrl.externalSystemConfiguration);
		}

        ctrl.hasChanges = function() {
                return ctrl.ssoChanged() || extenralSystemConfigurationChanged() ||
                !angular.equals(ctrl.originalSubDomain, ctrl.subDomain) ||
																				!angular.equals(ctrl.originalAllowedDomains, ctrl.allowedDomainsRoot.allowedDomains);
        };

        ctrl.ssoChanged = function() {
            return !angular.equals(ctrl.originalAuthMethodSettings, ctrl.authMethodSettings);
        };

        ctrl.isOriginalAuthProvider = function() {
            return angular.equals(ctrl.originalAuthMethodSettings.authenticationProvider.provider, ctrl.authMethodSettings.authenticationProvider.provider)
        }

        ctrl.providerChanged = function() {
            if (ctrl.isOriginalAuthProvider()) {
                ctrl.authMethodSettings = ctrl.originalAuthMethodSettings;
            }
        }

        ctrl.saveAuthSettings = function() {
            AccountAuthService.saveAuthSettings($state.params.accountId, ctrl.miniAccount(), function (data) {
                $scope.$broadcast('stop-load');
                if (data.status == "OK") {
                    $scope.$root.handleServerResponse(data, "", "Settings saved successfully");
                    ctrl.authMethodSettings = data.model.accountAuthSettings.ssoProviders[0];
                    ctrl.subDomain = data.model.accountAuthSettings.fqdn;
                    ctrl.initAccountAuthSettingsValues(ctrl.authMethodSettings);
                    initExternalSystem();
                    ctrl.originalAuthMethodSettings = angular.copy(ctrl.authMethodSettings);
                    ctrl.originalSubDomain = data.model.accountAuthSettings.fqdn;
																				if (data.model.accountAuthSettings.allowedDomains) {
																								let allowedDomainsNames = data.model.accountAuthSettings.allowedDomains.split(';');
																								ctrl.allowedDomainsRoot.allowedDomains = [];
																								allowedDomainsNames.forEach(name => ctrl.allowedDomainsRoot.allowedDomains.push({id: name, type: ctrl.type, display_name: name}));
																				}
																				ctrl.originalAllowedDomains = angular.copy(ctrl.allowedDomainsRoot.allowedDomains);
                } else {
                    $scope.$root.handleServerResponse(data, '', '');
                }
                $scope.$digest();
            });
        }

        ctrl.saveChanges = function() {
            if (ctrl.subDomain !== ctrl.originalSubDomain) {
                $scope.$root.confirm("Changing the subdomain for the account impacts email alerts and breaks links related to the old subdomain. In addition, all logins to the Cato Management Application and the SDP Clientless Portal must use the new subdomain. Do you want to continue? ", function () {
                    ctrl.saveAuthSettings();
                });
            } else {
                ctrl.saveAuthSettings();
            }
            $scope.$broadcast('stop-load');
            $scope.$broadcast('modelSavedEvent');
        };

        ctrl.getGlobalCloudApplicationAuthentication = function() {
            GlobalCloudApplicationAuthenticationService.getGlobalCloudApplicationAuthentication($state.params.accountId, ctrl.readCallback);
        };

        ctrl.readCallback = function(response) {
            if (response.status !== 'ERROR') {
                ctrl.setAuthenticationProviders(response.data.providers);
            } else {
                $scope.$root.handleServerResponse(data, '', '');
            }
            ctrl.readGlobals = true;
            ctrl.updateOrig();
        }

        ctrl.setAuthenticationProviders = function(data) {
            ctrl.applicationAuthentications = [];
            Object.keys(data).forEach(function(key) {
                if (data[key].uuid === 'GLOBAL_OAUTH2_AZURE') {
                    ctrl.azureClientId = data[key].svcOauth2Settings.clientId;
                }
                if (data[key].uuid === 'GLOBAL_OAUTH2_AZURE_VER_1') {
																				ctrl.azureVer1ClientId = data[key].svcOauth2Settings.clientId;
																}
                if (data[key].uuid != 'GLOBAL_OAUTH2_AZURE_VER_1') {
																				ctrl.authenticationProviders.push(ctrl.globalProviderUuidToAuthenticationProvider(data[key].uuid));
																}
            });
            ctrl.authenticationProviders.push(ctrl.oktaAuthenticationProvider);

            ctrl.authenticationProviders.push(ctrl.oneloginAuthenticationProvider);

            ctrl.authenticationProviders.push(ctrl.iwelcomeAuthenticationProvider);

            ctrl.authenticationProviders.push({
                name: 'None',
                method: 'NO_AUTH',
                provider: 'NONE'});
        }

								ctrl.addDomain = function () {
												$scope.$root.openPopup('addDomains');
								};

								ctrl.addDomains = function () {
												if (ctrl.domainsInput != null || ctrl.domainsInput != "") {
																ctrl.domainsInput.split(';').forEach(function (domain) {
																				if (!ctrl.allowedDomainsRoot.allowedDomains.includes(domain)) {
																								ctrl.allowedDomainsRoot.allowedDomains.push(domain);
																				}
																});
												}

												ctrl.domainsInput = '';
												ctrl.closeAddDomainsPopup();
								};

								ctrl.closeAddDomainsPopup = function () {
												$scope.$root.closePopup('addDomains');
								};

								ctrl.fields = {
												from: {
																name: 'From',
																id: 'allowedDomains',
																types: [
																				{
																								name: ctrl.type,
																								field: {
																												component: "text",
																												type: ctrl.type,
																												validate: (item) => {
																																if (!item) {
																																				return "Enter domain name";
																																}
																																if (item.includes(";")) {
																																				return "Invalid domain name"
																																}
																												},
																												output: (item) => {
																																item = item.trim();
																																return {
																																				id: item,
																																				type: ctrl.type,
																																				display_name: item,
																																}
																												},
																												placeHolder: 'myDomain.com'
																								},
																				}
																],
												}
								}

        ctrl.getAccountAuthSettings = function() {
            AccountAuthService.getAccountAuthSettings($state.params.accountId, function(data) {
                ctrl.accountAuthSettings = {};
                ctrl.accountAuthSettings = data.accountAuthSettings
                ctrl.authMethodSettings = {};
                if(ctrl.accountAuthSettings.ssoProviders.length !=0) {
                    ctrl.initAccountAuthSettingsValues(ctrl.accountAuthSettings.ssoProviders[0]);
                } else {
                    ctrl.initAccountAuthSettingsValues(defaultAuthMethodSettings);

                }
                ctrl.subDomain = ctrl.accountAuthSettings.fqdn;
																ctrl.allowedDomainsRoot = {};
																ctrl.allowedDomainsRoot.allowedDomains = [];
																if (data.accountAuthSettings.allowedDomains) {
																				let allowedDomainsNames = data.accountAuthSettings.allowedDomains.split(';');
																				allowedDomainsNames.forEach(name => ctrl.allowedDomainsRoot.allowedDomains.push({id: name, type: ctrl.type, display_name: name}));
																}
                ctrl.ssoSubDomain = ctrl.accountAuthSettings.domain;
                ctrl.readAccountData = true;
                ctrl.updateOrig();
                ctrl.originalAuthMethodSettings = angular.copy(ctrl.authMethodSettings);
                ctrl.originalSubDomain = ctrl.subDomain;
																ctrl.originalAllowedDomains = angular.copy(ctrl.allowedDomainsRoot.allowedDomains);


																ctrl.initCompleted = true;
                $scope.$digest();
            });
        }

        ctrl.updateOrig = function() {
            if (ctrl.readGlobals && ctrl.readAccountData) {
                if (!ctrl.authMethodSettings.authenticationProvider && ctrl.authenticationProviders[0]) {
                    ctrl.authMethodSettings.authenticationProvider = ctrl.authenticationProviders[0];
                }
                if (ctrl.authMethodSettings.authenticationProvider && ctrl.authMethodSettings.authenticationProvider.id) {
                    ctrl.authenticationProviders.forEach(provider => provider.id = ctrl.authMethodSettings.authenticationProvider.id);
                }
                if (ctrl.azureClientId) {
                    AccountAuthService.getServerUrl(ctrl.initAzureHref);
                }
            }
        }

        ctrl.initAzureHref = function(serverUrl) {
            ctrl.href = 'https://login.microsoftonline.com/organizations/v2.0/adminconsent?client_id=' + ctrl.azureClientId + '&state=' + $state.params.accountId + '&redirect_uri=' + serverUrl + '/sso/setAzureSsoProvider&scope=https://graph.microsoft.com/Directory.AccessAsUser.All https://graph.microsoft.com/Directory.Read.All https://graph.microsoft.com/User.Read';
            $scope.$digest();
        }

								ctrl.initAzureVer1Href = function(ssoUrl) {
												ctrl.hrefAzureVer1 = "https://login.windows.net/common/oauth2/authorize?response_type=code&client_id=" + ctrl.azureVer1ClientId + "&resource=https%3A%2F%2Fgraph.windows.net&redirect_uri=" + ssoUrl + "&state=registration|" + $state.params.accountId + "|" + ctrl.azureVer1ClientId + "&prompt=admin_consent";
												$scope.$digest();
								}

        ctrl.initAccountAuthSettingsValues = function (authMethodSettings) {
            let index;
            ctrl.authProviderId = GeneralUtilsService.getRandomId();
            if(authMethodSettings){
                ctrl.authMethodSettings.authenticationProvider = {
                    method: authMethodSettings.authMethod,
                    provider: authMethodSettings.authProvider,
                    name: authMethodSettings.authProviderDisplayName,
                    id: authMethodSettings.id
                }
                ctrl.authProviderId = authMethodSettings.id;
            }

            if (authMethodSettings && authMethodSettings.authProvider === 'NONE') {
                // In case no authentication provider, set none
                ctrl.authMethodSettings.authenticationProvider = {
                    name: 'None',
                    method: 'NO_AUTH',
                    provider: 'NONE'};
            }
            // IMPORTANT - keep this condition and variables! these variables may be changed from UI by clicking "Add Cato Cloud to my organization" but should not activate the save button so they are not part of ctr.settings
            if (authMethodSettings.tenantId) {
                ctrl.tenantId = authMethodSettings.tenantId;
                ctrl.lastTenantUpdateDate = authMethodSettings.lastTenantUpdateDate;
            }else {
                ctrl.tenantId = "";
                ctrl.lastTenantUpdateDate = "";
            }
            if (authMethodSettings && authMethodSettings.authProvider == 'OAUTH2_OKTA') {
                index = authMethodSettings.tenantId.indexOf('.');
                ctrl.authMethodSettings.clientDomain = authMethodSettings.tenantId.slice(0, index);
                ctrl.authMethodSettings.oktaSuffix = authMethodSettings.tenantId.slice(index);
                ctrl.authMethodSettings.clientId = authMethodSettings.clientId;
             }
            if (authMethodSettings && authMethodSettings.authProvider == 'OAUTH2_ONELOGIN') {
                index = authMethodSettings.tenantId.indexOf('.');
                ctrl.authMethodSettings.clientDomain = authMethodSettings.tenantId.slice(0, index);
                ctrl.authMethodSettings.oneloginSuffix = authMethodSettings.tenantId.slice(index);
                ctrl.authMethodSettings.clientId = authMethodSettings.clientId;
            }
												if (authMethodSettings && authMethodSettings.authProvider == 'OAUTH2_IWELCOME') {
																ctrl.authMethodSettings.clientDomain = authMethodSettings.tenantId;
																ctrl.authMethodSettings.clientId = authMethodSettings.clientId;
												}
        }

        ctrl.miniAccount = function() {
            // check changes on sso before changing stuff...
            let ssoChanged = ctrl.ssoChanged();
            let account = {};
            account.id = $state.params.accountId;
            account.newSaveMethod = true;
            if(!ctrl.accountAuthSettings){
                account.accountAuthSettings = {};
                account.accountAuthSettings.newSaveMethod = true;
                account.accountAuthSettings.type = "ACCOUNTAUTHSETTINGS";
            }else{
                account.accountAuthSettings = ctrl.accountAuthSettings;
            }
            if(!account.accountAuthSettings.ssoProviders){
                account.accountAuthSettings.ssoProviders = [];
            }
            account.accountAuthSettings.fqdn = ctrl.subDomain;
            let domains = '';
            let delimiter = '';
            ctrl.allowedDomainsRoot.allowedDomains.forEach(domain => {
                domains += delimiter;
                domains += domain.display_name;
                delimiter  = ';';
            });
            if (domains === '') {
                account.accountAuthSettings.allowedDomains = '';
            } else {
                account.accountAuthSettings.allowedDomains = domains;
            }
            account.accountAuthSettings.name = "AccountAuthSettings";
            account.accountAuthSettings.newSaveMethod = true;
            account.accountAuthSettings.ssoProviders[0] = ctrl.authMethodSettings;
            account.accountAuthSettings.ssoProviders[0].type = "AUTHMETHODSETTINGS";
            account.accountAuthSettings.account = $state.params.accountId;
            if (ctrl.authMethodSettings.authenticationProvider) {
                account.accountAuthSettings.ssoProviders[0].authMethod = ctrl.authMethodSettings.authenticationProvider.method;
                account.accountAuthSettings.ssoProviders[0].authProvider = ctrl.authMethodSettings.authenticationProvider.provider;
                account.accountAuthSettings.ssoProviders[0].authProviderDisplayName = ctrl.authMethodSettings.authenticationProvider.name;
                account.accountAuthSettings.ssoProviders[0].id = ctrl.authProviderId;
                account.accountAuthSettings.ssoProviders[0].name = 'AuthMethodSettings';
                account.accountAuthSettings.ssoProviders[0].globalProvider = (ctrl.authMethodSettings.authenticationProvider.name.toLowerCase().includes('azure') || ctrl.authMethodSettings.authenticationProvider.name.toLowerCase().includes('google'));
                // merge the okta domain
                if (ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_OKTA' && ssoChanged) {
                    account.accountAuthSettings.ssoProviders[0].tenantId = ctrl.authMethodSettings.clientDomain + ctrl.authMethodSettings.oktaSuffix;
                }
                if (ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_ONELOGIN' && ssoChanged) {
                    account.accountAuthSettings.ssoProviders[0].tenantId = ctrl.authMethodSettings.clientDomain + ctrl.authMethodSettings.oneloginSuffix;
                }
																if (ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_IWELCOME' && ssoChanged) {
																				account.accountAuthSettings.ssoProviders[0].tenantId = ctrl.authMethodSettings.clientDomain;
																}
                if (ctrl.authMethodSettings.authenticationProvider.provider == 'NONE' && ssoChanged) {
                    account.accountAuthSettings.ssoProviders[0].clientDomain = "" ;
                    account.accountAuthSettings.ssoProviders[0].clientId = "";
                    account.accountAuthSettings.ssoProviders[0].tenantId = "";
                }
                if ((ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_AZURE' || ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_AZURE_VER_1' || ctrl.authMethodSettings.authenticationProvider.provider == 'OAUTH2_GOOGLE') && ssoChanged) {
                    // Azure tenant id is being accepted in SsoController separatly
                    //checking if the tenant exist but is not the prev tenant of Okta or Onelogin
                    if(ctrl.tenantId != null && (ctrl.tenantId == ctrl.authMethodSettings.clientDomain + ctrl.authMethodSettings.oneloginSuffix || ctrl.tenantId == ctrl.authMethodSettings.clientDomain + ctrl.authMethodSettings.oktaSuffix || ctrl.tenantId == ctrl.authMethodSettings.clientDomain)){
                        account.accountAuthSettings.ssoProviders[0].tenantId = "";
                    }
                    else if(ctrl.tenantId != null) {
                        account.accountAuthSettings.ssoProviders[0].tenantId = ctrl.tenantId;
                    }else{
                        account.accountAuthSettings.ssoProviders[0].tenantId = "";
                    }
                }
                if (!account.accountAuthSettings.ssoProviders[0].globalProvider) {
                    account.accountAuthSettings.ssoProviders[0].clientId = ctrl.authMethodSettings.clientId;
                    account.accountAuthSettings.ssoProviders[0].clientSecret = ctrl.authMethodSettings.clientSecret;
                    account.accountAuthSettings.ssoProviders[0].clientDomain = ctrl.authMethodSettings.clientDomain;
                }
                if (ctrl.externalSystemConfiguration) {
                	account.externalSystemConfiguration = ctrl.externalSystemConfiguration;
				}
            }
            return account;

        }
    }
});

